import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Moon, ArrowRight, CalendarDays } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api, formatCHF, formatDate } from "@/lib/api";
import { isSpeciale } from "@/components/EventCard";

export const useSpeciale = () => {
  const [ev, setEv] = useState(null);
  useEffect(() => {
    api.events().then((all) => setEv(all.find((e) => e.type === "stage" && isSpeciale(e)) || null)).catch(() => {});
  }, []);
  return ev;
};

export const SuperLuneEncart = ({ className = "" }) => {
  const ev = useSpeciale();
  if (!ev) return null;
  const to = "/super-lune";
  return (
    <Reveal className={className}>
      <Link to={to} data-testid="superlune-encart"
        className="group relative block overflow-hidden rounded-2xl bg-earth grain text-sand border border-terra/50 p-7 lg:p-9 hover:border-terra transition-colors duration-500">
        <div className="relative z-[2] flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-terra flex items-center gap-2 mb-3"><Moon className="w-3.5 h-3.5" /> Prochaine création spéciale</p>
            <h3 className="font-serif text-2xl sm:text-3xl leading-tight">{ev.titre}</h3>
            <p className="text-sand/70 text-sm leading-relaxed mt-3 line-clamp-2">{ev.description}</p>
            <p className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-4 text-sm text-sand/80" data-testid="superlune-encart-infos">
              <span className="inline-flex items-center gap-2 capitalize"><CalendarDays className="w-4 h-4 text-terra" />{formatDate(ev.date)}</span>
              {ev.duree && <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-terra">{ev.duree}</span>}
              {ev.prix != null && <span className="font-serif text-terra">{formatCHF(ev.prix)}</span>}
            </p>
          </div>
          <span className="inline-flex items-center gap-2 self-start md:self-center shrink-0 px-6 py-3 rounded-full bg-terra text-earth text-sm group-hover:bg-sand transition-colors duration-300">
            Voir cette édition <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
};
